module.exports = __webpack_public_path__ + "static/media/magazineTupp_01_thumb.33b7775a.png";